import ProjectCancelModalModule from './project-cancel-modal.module'

export default ProjectCancelModalModule
